import React from 'react';
import PropTypes from 'prop-types';
import { EMPTINESS_SIGN } from 'rp-react-table';

/**
 * Formats a ratio cell, e.g.: a/b
 * @param {number} a - Divident.
 * @param {number} b - Divisor.
 */
const RatioCell = ({ a, b }) => (
    (a === 0 && b === 0) ?
        <span>{EMPTINESS_SIGN}</span> :
        <span><strong>{a}</strong>/<wbr />{b}</span>
);

RatioCell.propTypes = {
    a: PropTypes.number.isRequired,
    b: PropTypes.number.isRequired,
};

export default RatioCell;



// WEBPACK FOOTER //
// ./src/js/shared/cells/RatioCell.jsx